export const testimonials = [
  {
    id: 1,
    name: '李明远',
    role: '资深影迷',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20man%20with%20confident%20smile%2C%20neutral%20warm%20background%2C%20natural%20soft%20lighting%2C%20clean%20minimalist%20professional%20photography%20style&width=200&height=200&seq=avatar-1&orientation=squarish',
    content: '91视频网站是我用过最全面的视频导航平台，分类清晰，资源丰富。无论是找老电影还是追新剧，这里都能一站式解决，省了我大量时间！',
    rating: 5,
  },
  {
    id: 2,
    name: '张雅琪',
    role: '自媒体创作者',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20woman%20with%20warm%20friendly%20expression%2C%20soft%20neutral%20background%2C%20natural%20daylight%20lighting%2C%20elegant%20minimalist%20professional%20photography%20style&width=200&height=200&seq=avatar-2&orientation=squarish',
    content: '作为一名内容创作者，我需要大量参考视频素材。91视频网站的文章资讯板块特别有价值，行业分析和拍摄技巧让我受益匪浅。',
    rating: 5,
  },
  {
    id: 3,
    name: '王浩然',
    role: '在校学生',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20male%20student%20with%20glasses%20and%20casual%20style%2C%20warm%20neutral%20background%2C%20natural%20soft%20lighting%2C%20friendly%20relaxed%20professional%20photography%20style&width=200&height=200&seq=avatar-3&orientation=squarish',
    content: '纪录片和公开课资源非常齐全，学习之余还能看看动漫放松。界面设计很清爽，没有乱七八糟的广告，体验非常棒。',
    rating: 4,
  },
];

export const stats = [
  { label: '视频资源', value: '50,000+' },
  { label: '日活跃用户', value: '120万' },
  { label: '内容分类', value: '28个' },
  { label: '用户满意度', value: '98.5%' },
];